import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/auctions";
import type { ResponseConfig } from "@/api/client/auctions";
import type { UpdateAuctionMutationRequest, UpdateAuctionMutationResponse, UpdateAuctionQueryParams, UpdateAuction400, UpdateAuction404 } from "../types/UpdateAuction";

/**
 * @description Метод предназначен для редактирования предложения (аукциона   ) https://confluence.poleinvest.ru/pages/viewpage.action?pageId=425486312

 * @link /v1/auction/do_update
 */

export function useUpdateAuction <TData = UpdateAuctionMutationResponse, TError = UpdateAuction400 | UpdateAuction404, TVariables = UpdateAuctionMutationRequest>(params: UpdateAuctionQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/v1/auction/do_update`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
